import React from 'react';
import { darken, makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import StoreProvider from 'store/store';
import { ContributionSummaryType } from 'store/modules/Contributions/types';
import { formatCurrency } from 'utils';

const { selectors, connect } = StoreProvider;

const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      backgroundColor: theme.palette.secondary.main,
      position: 'relative',
      padding: '2rem 2rem',
      height: '69px',
      zIndex: 10,
      boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
      borderRadius: ' 38px'
    },
    title: {
      color: '#fff',
      width: '11.25rem',
      fontWeight: 600
    },
    contributionBox: {
      margin: '0.2rem 0',
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    },
    bar: {
      width: '60%',
      marginLeft: '2rem',
      height: '24px',
      backgroundColor: darken(theme.palette.primary.main, 0.2),
      borderRadius: '10px',
      display: 'flex',
      alignItems: 'center'
    },
    progress: {
      backgroundColor: theme.palette.primary.main,
      minHeight: '100%',
      borderRadius: '10px'
    },
    value: {
      fontWeight: 600,
      color: '#fff',
      margin: '0 0.2rem',
      padding: '2px 0 0 5px',
      marginRight: '1.5rem'
    }
  };
});

interface ContributionsSummaryProps {
  contributionSummary: ContributionSummaryType;
}

const ContributionsSummary = ({
  contributionSummary
}: ContributionsSummaryProps) => {
  const { unallocated_existing, unallocated_existing_percentage } =
    contributionSummary;
  const classes = useStyles();

  return (
    <Grid
      container
      className={classes.container}
      direction="column"
      justifyContent="center"
    >
      <Grid item className={classes.contributionBox}>
        <span className={classes.title}>Unallocated existing money</span>
        <div className={classes.bar}>
          <div
            className={classes.progress}
            style={{ width: `${unallocated_existing_percentage}%` }}
          />
          <span className={classes.value}>
            {formatCurrency(unallocated_existing)}
          </span>
        </div>
      </Grid>
    </Grid>
  );
};

export default connect((state: any) => ({
  contributionSummary: selectors.caseSelectors.contributionSummary(state)
}))(ContributionsSummary);
